import Image from 'react-bootstrap/Image'
import React from 'react'

const Logo = ({widthClass = null}: {widthClass: string | null}) => {
    return (
        <Image
            src={'/images/logo-florajet.svg'}
            alt={'Mon Florajet'}
            className={`img-fluid ${widthClass}`}
        />
    )
}

export default Logo
